import { BlockType } from '@next-space/fe-api-idl';
import { i18n } from '@flowus/common/i18n';

export const getFileClass = (type: BlockType) => {
  let fileType = '';
  if (type === BlockType.FOLDER) {
    fileType = i18n.t('common.folder');
  } else if (type === BlockType.FILE) {
    fileType = i18n.t('common.file');
  } else {
    fileType = i18n.t('common.page');
  }
  return fileType;
};

export const VIDEO_FORMAT = 'video/*,.mpg,.3gp,.asf,.avi,.f4v,.flv,.mkv,.rmvb,.wmv';
export const AUDIO_FORMAT = 'audio/*,.ogg,.m4a,.amr,.ac3,.wma,.ape';
